import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const previewArticles = [
  {
    label: 'Beginner Guide',
    labelClass: 'text-accent-700 bg-accent-100',
    title: 'What is Sugargoo Spreadsheet? Complete Beginner Guide',
    description: 'Everything you need to know about using Sugargoo spreadsheets for smarter shopping',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20with%20laptop%20showing%20organized%20spreadsheet%2C%20warm%20cream%20interior%2C%20soft%20morning%20sunlight%2C%20minimal%20workspace%20with%20plant%20and%20notebook%2C%20editorial%20photography%2C%20terracotta%20and%20neutral%20accents%2C%20productive%20aesthetic&width=600&height=450&seq=art-new-guide-2026&orientation=landscape',
    linkTo: '/sugargoo-spreadsheet-guide',
  },
  {
    label: 'Tutorial',
    labelClass: 'text-secondary-700 bg-secondary-100',
    title: 'How to Order Using Sugargoo Spreadsheet',
    description: 'Step-by-step walkthrough for placing orders through Sugargoo spreadsheet links',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20shopping%20cart%20on%20warm%20cream%20desk%2C%20soft%20natural%20daylight%2C%20minimal%20lifestyle%20photography%2C%20editorial%20style%2C%20neutral%20and%20sage%20green%20accents%2C%20clean%20composition&width=600&height=450&seq=art-new-howto-2026&orientation=landscape',
    linkTo: '/articles/how-to-order-sugargoo-spreadsheet',
  },
  {
    label: 'Comparison',
    labelClass: 'text-accent-700 bg-accent-100',
    title: 'Sugargoo vs Pandabuy: Spreadsheet Comparison',
    description: 'Side-by-side comparison of features, fees, and user experience',
    imageUrl: 'https://readdy.ai/api/search-image?query=Split%20screen%20design%20showing%20two%20platform%20interfaces%20comparison%20on%20warm%20minimal%20background%2C%20clean%20graphic%20aesthetic%2C%20soft%20lighting%2C%20modern%20UI%20style%2C%20cream%20and%20coral%20accents&width=600&height=450&seq=art-new-compare-2026&orientation=landscape',
    linkTo: '/articles/sugargoo-vs-pandabuy-comparison',
  },
];

const labelColorMap: Record<string, string> = {
  accent: 'text-accent-700 bg-accent-100',
  secondary: 'text-secondary-700 bg-secondary-100',
  primary: 'text-primary-700 bg-primary-100',
};

export default function ArticlePreview() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              Latest Guides &amp; Spreadsheet Updates
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">
            In-depth articles to help you get the most out of your Sugargoo spreadsheet experience
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-10">
          {previewArticles.map((item) => (
            <Link
              key={item.title}
              to={item.linkTo}
              className="rounded-2xl overflow-hidden bg-background-100 group cursor-pointer block"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${item.labelClass}`}>
                  {item.label}
                </span>
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mt-3 mb-2">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <h3 className="font-heading text-2xl font-bold text-foreground-950 mb-6">
          More Sugargoo Guides &amp; Tips
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/articles/${article.slug}`}
              className="group flex items-start gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer"
            >
              <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${labelColorMap[article.labelColor] || labelColorMap.secondary}`}>
                  {article.label}
                </span>
                <h4 className="font-heading text-sm font-bold text-foreground-950 mt-1.5 mb-1 leading-snug line-clamp-2">
                  {article.title}
                </h4>
                <p className="text-xs text-foreground-500 line-clamp-1">{article.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}